<template>
	<div class="trade-mark">
		<!-- header -->
		<!-- <div class="trade-mark.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="trade-mark.block">
			<intellectual-navigation :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="trade-mark.bread" data-aos="fade-left">
			<Bread :currentPage="{name:'商标商城',path:'/Trademark'}" />
		</div>
		<div class="trade-mark.container">
			<div class="trade-mark.item" data-aos="fade-right">
				<img src="../assets/trademarks/trade-head.jpg" alt="">
			</div>
			<div class="trade-mark.item +content-box">
				<section>
					<!-- 筛选菜单 -->
					<SelectMenus :allMenus="allMenus" data-aos="fade-right" @menusTabs="menusTabs"></SelectMenus>
					<!-- 筛选时间和价格 -->
					<select-tabs 
					:selectTabs="{type:'商标',account:account}" 
					 data-aos="fade-right" @searchEvent="searchEvent" 
					 @priceSortEvent="priceSortEvent" @timeSortEvent="timeSortEvent">
					 </select-tabs>
					<!-- 筛选得内容 -->
					<select-lists :lists="tradeData" :pageParams="pageParams" @updateLists="updateLists"></select-lists>
				</section>
				<section>
					<!-- 商标注册 -->
					<trade-sigin data-aos="fade-left" @showTipsEvent="showTipsEvent"></trade-sigin>
					<!-- 商标名称征集 -->
					<trade-collect data-aos="fade-left" @showTipsEvent="showTipsEvent"></trade-collect>
					<!-- 注册流程 -->
					<trade-progress></trade-progress>
				</section>
			</div>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
		<tips-modal :tipsShow="tipsShow" @closeTipsEvent="closeTipsEvent"></tips-modal>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'
	import SelectMenus from '../components/select-menus.vue'
	import SelectTabs from "../components/select-tabs.vue"
	import SelectLists from '../components/select-lists.vue'
	import TradeSigin from '../components/trade-sigin.vue'
	import TradeCollect from '../components/trade-collect.vue'
	import TradeProgress from '../components/trade-progress.vue'
	import TipsModal from '../components/tips-modal.vue'

	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,
			SelectMenus,
			SelectTabs,
			SelectLists,
			TradeSigin,
			TradeCollect,
			TradeProgress,
			TipsModal

		},
		data() {
			return {
				isTrademark: false,
				account: 0,
				searchVal: '',
				pageParams: {
					totalMCount: 0,
					pageMNo: 1,
				},
				tipsShow: false,
				priceSort:'',
				timeSort:'',
				allMenus: [{
						type: '商标分类',
						lists: [{
								name: '01类-化学原料',
								id: 16
							},
							{
								name: '02类-颜料油漆',
								id: 17
							},
							{
								name: '03类-日化用品',
								id: 18
							},
							{
								name: '04类-燃料油脂',
								id: 19
							},
							{
								name: '05类-医药',
								id: 20
							},
							{
								name: '06类-金属材料',
								id: 21
							},
							{
								name: '07类-机械设备',
								id: 23
							},
							{
								name: '08类-手工器械',
								id: 23
							},
							{
								name: '09类-科学仪器',
								id: 24
							},
							{
								name: '10类-医疗器械',
								id: 25
							},
							{
								name: '11类-灯具空调',
								id: 26
							},
							{
								name: '12类-运输工具',
								id: 27
							},
							{
								name: '13类-军火烟火',
								id: 28
							},
							{
								name: '14类-珠宝钟表',
								id: 29
							},
							{
								name: '15类-乐器',
								id: 30
							},
							{
								name: '16类-办公用品',
								id: 31
							},
							{
								name: '17类-橡胶制品',
								id: 32
							},
							{
								name: '18类-皮革皮具',
								id: 33
							},
							{
								name: '19类-建筑材料',
								id: 34
							},
							{
								name: '20类-家具',
								id: 35
							},
							{
								name: '21类-厨具洁具',
								id: 36
							},
							{
								name: '22类-绳网袋篷',
								id: 37
							},
							{
								name: '23类-纱线丝',
								id: 38
							},
							{
								name: '24类-布料床单',
								id: 39
							},
							{
								name: '25类-服装鞋帽',
								id: 40
							},
							{
								name: '26类-纽扣拉链',
								id: 41
							},
							{
								name: '27类-地毯席垫',
								id: 42
							},
							{
								name: '28类-健身器材',
								id: 43
							},
							{
								name: '29类-食品',
								id: 44
							},
							{
								name: '30类-方便食品',
								id: 45
							},
							{
								name: '31类-饲料种籽',
								id: 46
							},
							{
								name: '32类-啤酒饮料',
								id: 47
							},
							{
								name: '33类-酒',
								id: 48
							},
							{
								name: '34类-烟草烟具',
								id: 49
							},
							{
								name: '35类-广告销售',
								id: 50
							},
							{
								name: '36类-金融物管',
								id: 51
							},
							{
								name: '37类-建筑修理',
								id: 52
							},
							{
								name: '38类-通讯服务',
								id: 53
							},
							{
								name: '39类-运输贮藏',
								id: 54
							},
							{
								name: '40类-材料加工',
								id: 55
							},
							{
								name: '41类-教育娱乐',
								id: 56
							},
							{
								name: '42类-网站服务',
								id: 57
							},
							{
								name: '43类-餐饮住宿',
								id: 58
							},
							{
								name: '44类-医疗园艺',
								id: 59
							},
							{
								name: '45类-社会服务',
								id: 60
							}
						],
						isShowBtn: true,
					},
					{
						type: '组合类型',
						lists: [{
							name: '文字商标'
						}, {
							name: '图文商标'
						}, {
							name: '组合商标'
						}],
						isShowBtn: false
					},
					{
						type: '商标字数',
						lists: [{
							name: '1-2个字'
						}, {
							name: '3个字'
						}, {
							name: '4个字'
						}, {
							name: '5个字及以上'
						}],
						isShowBtn: false
					}
				],
				tradeLists: [{
					title: 'SEBE 拾贝',
					desc: '让创新保护，不再困难',
					icon: require('../assets/trademarks/list-test.png'),
					id: 0
				}, ],
				attribute_id: '',
				compose: '',
				number: ''
			}
		},
		computed: {
			tradeData() {
				return this.tradeLists.map(({
					name,
					image,
					description,
					id
				}) => {
					return {
						title: name,
						icon: this.imgUrl + image,
						desc: description,
						id: id,
					}
				})
			}
		},
		watch: {
			$route() {
				if (this.$route.query) {
					this.initTradeLists()
				}
			},
		},
		methods: {
			showTipsEvent(val) {
				this.tipsShow = val
			},
			closeTipsEvent(val) {
				this.tipsShow = val
			},
			toggleTrademarks(val) {
				this.isTrademark = val
			},
			initTradeLists(page) {
				page = page ? page : 1;
				let attribute_id; 
				if(this.attribute_id){
					attribute_id= this.attribute_id
				}else{
					if(this.$route.query.id){
						attribute_id= parseInt(this.$route.query.id) + 15
					}else{
						attribute_id = ''
					}
				}
				
				this.http.get(
					`IPR_Trademark?page=${page}&name=${this.$route.query.name ? this.$route.query.name : this.searchVal}&price=${this.priceSort}&check_time=${this.timeSort}&attribute_id=${attribute_id}&category_id=${this.$route.query.category_id || ''}`
				).then(res => {
					this.tradeLists = res.data.data
					this.pageParams.totalMCount = res.data.total
					this.account = res.data.total

				})
			},
			updateLists(val) {
				this.initTradeLists(val)
			},
			searchData() {
				this.http.get(
					`IPR_Trademark?name=${this.searchVal}&attribute_id=${this.attribute_id}&compose=${this.compose}&number=${this.number}&price=${this.priceSort}&check_time=${this.timeSort}`
				).then(res => {
					this.tradeLists = res.data.data
					this.pageParams.totalMCount = res.data.total
					this.account = res.data.total

				})
			},
			searchEvent(keyValue) {
				this.searchVal = keyValue
				this.searchData()

			},
			menusTabs(tabs) {
				let tradeId = [],
					composeId = [],
					numberId = [];
				tabs.map((item, index) => {
					if (item.type.slice(0, 4) == '商标分类') {
						tradeId.push(parseInt(item.type.slice(7)) + 16)
					}
					if (item.type.slice(0, 4) == '组合类型') {
						composeId.push(parseInt(item.type.slice(7)) + 1)
						console.log(composeId)
					}
					if (item.type.slice(0, 4) == '商标字数') {
						numberId.push(parseInt(item.type.slice(7)) + 1)
					}
				})

				this.attribute_id = tradeId.join(',');
				this.compose = composeId.join(',')
				this.number = numberId.join(',')
				this.searchData()
			},
			priceSortEvent(type){
				this.priceSort = type.priceType
				this.timeSort= type.timeType
					this.searchData()
			},
			timeSortEvent(type){
				this.priceSort = type.priceType
				this.timeSort= type.timeType
				this.searchData()
			
			}

		},
		mounted() {
			window.scrollTo(0,0);
			this.initTradeLists()
		}
	}
</script>

<style lang="scss">
	@include component(trade-mark) {
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}

		@include part(bread) {
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}

		@include part(container) {
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;

		}

		@include part(item) {
			width: 1200px;
			margin: 0 auto;
			padding-top: 18px;
			padding-bottom: 18px;
		}

		@include tweak(content-box) {
			display: flex;
			justify-content: space-between;
			padding-top: 0;

			section {

				&:nth-child(1) {
					width: 940px;

				}

				&:nth-child(2) {
					width: 240px;
				}
			}
		}
	}
</style>
